module.exports = __webpack_public_path__ + "static/cloudBean.7ef3bba7.png";